"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_dom_1 = require("react-dom");
class OutsideEventBehavior extends React.Component {
    constructor() {
        super(...arguments);
        this.handleClickEvent = (event) => {
            const el = (0, react_dom_1.findDOMNode)(this); // eslint-disable-line react/no-find-dom-node
            if (!this.props.onClick ||
                !el ||
                (event.target instanceof Node && el.contains(event.target)) // eslint-disable-line no-undef
            ) {
                return;
            }
            this.props.onClick(event);
        };
    }
    componentDidMount() {
        document.addEventListener('click', this.handleClickEvent, {
            capture: true,
        });
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickEvent, {
            capture: true,
        });
    }
    render() {
        return this.props.children;
    }
}
OutsideEventBehavior.propTypes = {
    children: prop_types_1.default.node,
    onClick: prop_types_1.default.func,
};
OutsideEventBehavior.defaultProps = {
    children: undefined,
    onClick: undefined,
};
exports.default = OutsideEventBehavior;
